import DataAccess from './constants';
import API from './API'

const path = 'DisplayAreas'
let api = new API(DataAccess.apiUrl, DataAccess.userName, DataAccess.password);

export const apiDisplayAreas = (type) => {
    let newpath = path + "?type=" + type;
    return api.getData(newpath)
}

export const apiDisplayAreasById = (id) => {
    let newpath = path + "?DisplayArea=" + id;
    return api.getData(newpath)
}

export const apiDisplayAreasByIdAndType = (id, type) => {
    let newpath = path + "?DisplayArea=" + id + "&type=" + type;
    return api.getData(newpath)
}